'use strict';

import $ from 'jquery';
import storage from './storage';
import Mustache from 'mustache';
import filterBar from './filter-bar';
import 'select2';

let tyreselector = {
  tsEl: $('#tyreselector_4:first'),
  language: $(document.body).data('language'),

  toggleTsViews: function() {
    var self = this;

    // show/hide ts4 forms
    if (!self.tsEl.length) {
      return false;
    }

    var tsViews = self.tsEl.find('.tsViews.toggle'),
      toggler = self.tsEl.find('header a.toggler'),
      closeStr = $(toggler).attr('data-title-close'),
      openStr = $(toggler).attr('data-title-open');

    // actions to do when closing tsViews
    function doClosing(storeState) {
      storeState = storeState === false ? false : true;
      // remove closeSearchOnLoad flag if it exists
      if (typeof window.cookieObj.closeSearchOnLoad !== 'undefined')
        delete window.cookieObj.closeSearchOnLoad;
      // hide form elements
      $(tsViews).hide();
      var tsViewsState = 'hidden';
      // store hidden state
      if (storeState) {
        window.cookieObj.tsViews = tsViewsState;
      }
      window.setTyreCookie();
      // change link title attribute
      $(toggler).attr('title', tsViewsState === 'visible' ? closeStr : openStr);
      // rotate arrow
      $(toggler).toggleClass('closed', tsViewsState === 'hidden');
    } // doClosing();

    // Init: add toggler function to link
    if (!$(tsViews).hasClass('ready')) {
      // run init only once
      $(tsViews).toggleClass('ready', true);

      // CHOOSE OPEN/CLOSE VIEWSTATE

      // always open in frontpage
      if (self.tsEl.hasClass('home') || self.tsEl.hasClass('in-hero')) {
        tsViews.show();
      }
      // if element is set to be closed on next page load
      else if (window.cookieObj && window.cookieObj.closeSearchOnLoad) {
        doClosing();
      }
      // Always close tyreselector on by-tyre-size page
      else if (self.tsEl.hasClass('by-tyre-size')) {
        doClosing();
      }
      // has user previously hidden forms by clicking toggle link?
      else if (
        (self.tsEl.hasClass('tyres') || self.tsEl.hasClass('tyre')) &&
        window.cookieObj &&
        window.cookieObj.tsViews &&
        window.cookieObj.tsViews === 'hidden'
      ) {
        doClosing();
      }
      // if it's the tyre-page and user has chosen size, close without saving state
      else if (
        self.tsEl.hasClass('tyre') &&
        window.cookieObj &&
        window.cookieObj.width &&
        window.cookieObj.height &&
        window.cookieObj.rim
      ) {
        doClosing(false);
      } else if (
        self.tsEl.hasClass('closed-by-default') &&
        (!window.cookieObj || !window.cookieObj.tsViews)
      ) {
        doClosing();
      } else {
        $(tsViews).show();
        window.cookieObj.tsViews = 'visible';

        window.setTyreCookie();
        // change link title attribute
        $(toggler).attr(
          'title',
          window.cookieObj.tsViews === 'visible' ? closeStr : openStr
        );
        // rotate arrow
        $(toggler).toggleClass('closed', window.cookieObj.tsViews === 'hidden');
      }

      // append toggle function to toggle link
      self.tsEl.each(function() {
        $(toggler).on('click', function(e) {
          e.preventDefault();
          self.toggleTsViews();
        });
      });
    } else {
      // store state
      window.cookieObj.tsViews =
        window.cookieObj.tsViews && window.cookieObj.tsViews === 'visible'
          ? 'hidden'
          : 'visible';

      window.setTyreCookie();

      // change link title attribute
      $(toggler).attr(
        'title',
        window.cookieObj.tsViews === 'visible' ? closeStr : openStr
      );

      // chage link state
      $(toggler).toggleClass('closed', window.cookieObj.tsViews === 'hidden');

      // hide/show forms
      $(tsViews).slideToggle('fast');
    }
  },
  notEditorInit: function() {
    var self = this;

    $('.tsView').hide();

    var tsViewNavItems = $('.tsViewNav li');

    if (
      typeof document.location.hash !== 'undefined' &&
      document.location.hash
    ) {
      /* If page was requested with hash and viewNav has matching link, click link */
      tsViewNavItems.each(function() {
        var href = $(this)
          .find('a:first')
          .attr('href');
        if (href === document.location.hash) {
          tsViewNavItems.toggleClass('active', false);
          $(this).toggleClass('active', true);
        }
      });
    } else if (window.cookieObj.tsViewNavItem) {
      /* Check if cookie contains value for selected view (select by carmodel/tyresize) and select it */
      tsViewNavItems.each(function() {
        var href = $(this)
          .find('a:first')
          .attr('href');
        if (href === window.cookieObj.tsViewNavItem) {
          tsViewNavItems.toggleClass('active', false);
          $(this).toggleClass('active', true);
        }
      });
    }

    // build view menu
    tsViewNavItems.each(function() {
      // find first active item, make it visible and store view state.
      if ($(this).hasClass('active')) {
        var initView = $(this)
          .find('a:first')
          .attr('href');
        $(initView).show();
        if (window.cookieObj) {
          // save view state
          window.cookieObj.tsViewNavItem = initView;

          window.setTyreCookie();
        }
      }

      // tsView change links
      $(this)
        .find('a')
        .on('click', function(e) {
          window.cookieObj.tsViewNavItem = $(this).attr('href');

          window.setTyreCookie();
          if (typeof self.parseResults !== 'undefined') self.parseResults(); // this updates header as well
          e.preventDefault();
          var target = $(this).attr('href');
          // ?gclid=234 param changes href from #filterSizes to https://www.nokianrenkaat.fi/?_gl=1*owobhv*_up*MQ..&amp;gclid=4567#filterSizes
          // And target is no longer a valid selector
          // Quick fix to get hash only.
          if(typeof target === 'string') {
            target = target.substring(target.indexOf('#'));
          }

          $('.tsViewNav li').toggleClass('active', false);
          $(this)
            .parents('li')
            .toggleClass('active', true);
          $('.tsView').hide();
          $(target).fadeIn('fast');

        }); // click
    }); // tsViewNavItems

  }, // notEditorInit()

  /*
    -------------------------------------------
    COMMON FUCTIONS TO ALL TYRESELECTOR FORMS
    -------------------------------------------
  */

  /**
   * Converts session data object to session storage key.
   *
   * @param {object} object Data to convert as key.
   * @returns {string} Session storage key.
   */
  _getSessionKeyFromObject: function(object = {}) {
    const ignoredProps = object.tyreSelectorVersion === 'fitment' ? ['tyreSize', 'lang', 'countryId', 'countryCode'] : ['tyreSize', 'stage-language'];
    const propMap = {
      'stage-language': 'l',
      tyreSelectorVersion: 'tsv',
      countryId: 'drci',
      countryCode: 'drcc'
    };

    let key = '';
    Object.keys(object).forEach(prop => {
      if (ignoredProps.includes(prop)) {
        return;
      }

      // Replace prop with shortend name (if shortend is not defined in paramObj)
      const propName = propMap[prop] && typeof object[propMap[prop]] === 'undefined' ? propMap[prop] : prop;

      // Convert prop value to string
      let value = String(object[prop]);
      if (typeof object[prop] === 'undefined' || object[prop] === null) {
        value = '';
      }

      // Add non-empty property as part of key
      if (propName && value !== '') {
        if (key) {
          key += '_';
        }

        key += propName + ':' + value;
      }
    });
    return key;
  },

  storeSessionData: function(data, paramObj) {
    const key = this._getSessionKeyFromObject(paramObj);
    sessionStorage.setItem(key, JSON.stringify(data));
  }, // storeSessionData()

  getSessionData: function(paramObj, returnDefaultSizeData) {
    var data, key;

    if (!storage.session) {
      // no support for localstorage, fallback to ajax
      console.warn('no storage support');
      return false;
    }

    // return defaultSizeData if it was requested
    if (returnDefaultSizeData) {
      if (!paramObj.vehicle) return false;

      key = 'primaryOption_' + paramObj.vehicle;
    }
    // other data
    else {
      key = this._getSessionKeyFromObject(paramObj);
    }

    try {
      data = sessionStorage.getItem(key);
      data = JSON.parse(data);
      return data;
    } catch (e) {
      return false;
    }
  }, // getSessionData()

  modifyTsSubmitButton: function($button, addSecondaryAction) {
    // this function add/removes secondary action of form's submit button.
    // it also changes button's text accordingly

    if (typeof $button === 'undefined' || !$button) return false;

    var buttonAction = 'scroll', // or 'scroll' if page should scroll to results and leave search open
      btnClassName = buttonAction === 'scroll' ? 'scrollPage' : buttonAction,
      btnText;

    // add action className to button and change text
    if (typeof addSecondaryAction !== 'undefined' && addSecondaryAction) {
      $button.addClass(btnClassName);
      btnText = $button.attr('data-secondary-text');
    }
    // reset button's default action and text
    else {
      $button.removeClass(btnClassName);
      btnText = $button.attr('data-primary-text');
    }

    // change text
    if ($button[0].nodeName === 'INPUT') {
      $button.val(btnText);
    } else {
      $button.html(btnText);
    }
  }, // modifyTsSubmitButton

  resetTyreSelectorForms: function(formNames) {
    var self = this;

    /*
      resets requested/all tyreselector forms

      if forms are defined in "formNames", then only those forms results are removed, inputs reseted and their stored data will be removed.
      NOTE: this does not remove width/height/rim
    */

    var reseted = {
      license: false,
      model: false,
      size: false
    };

    if (typeof formNames === 'undefined')
      formNames = ['licenseSearchForm', 'modelSearchForm', 'sizeSearchForm'];

    if (
      formNames.indexOf('licenseSearchForm') !== -1 &&
      typeof self.licenseForm !== 'undefined'
    ) {
      reseted.license = self.licenseForm.resetLicenseForm();
    }

    if (
      formNames.indexOf('modelSearchForm') !== -1 &&
      typeof self.modelForm !== 'undefined'
    ) {
      var resetCookieValues = true,
        removeResults = true;
      reseted.model = self.modelForm.resetModelForm(
        resetCookieValues,
        removeResults
      );
      self.modelForm.refreshVehicleData();
    }

    if (
      formNames.indexOf('sizeSearchForm') !== -1 &&
      typeof self.sizeForm !== 'undefined'
    ) {
      reseted.size = self.sizeForm.resetSizeForm();
    }

    return reseted;
  }, // resetTyreSelectorForms


  // update ts header bar content
  updateTsHeader: function(viewKey) {
    var self = this;

    var version = self.tsEl.hasClass('tyres') ? 'tyres' : 'tyre',
      // choose default text for element. Try to extract it from db's `hero_content` field which is stored in window.filterHtml
      headerText;

    // Header text
    // Try to use content from db's new field `product_list_heading`
    if (
      typeof window.productListHeading !== 'undefined' &&
      window.productListHeading
    )
      headerText = window.productListHeading;
    // Search for <h1> in window.filterHtml. This the old `hero_content` in db
    else if (
      !viewKey &&
      version === 'tyres' &&
      window.filterHtml &&
      $(window.filterHtml).filter('h1').length
    )
      headerText = $(window.filterHtml).filter('h1')[0].innerHTML;
    // fallback to slogan from localizations
    else headerText = window.loc.tyreselector_slogan;

    // choose content to show
    var headerHtml = viewKey
        ? Mustache.render(
          window['header_' + viewKey + '_template'],
          window.cookieObj
        )
        : '<span>' + headerText + '</span>',
      // try to get dom nodeName to use from parent element's attribute. This way the HTML is defined @ page, not here in JS
      wrapNodeName =
        self.tsEl
          .find('.ts-header > .content:first')
          .attr('data-wrap-el-' + version) || 'h3', // fallback to <h3>
      wrapEl = $(
        '<' + wrapNodeName + ' class="h2">' + '</' + wrapNodeName + '>'
      );

    if (headerHtml) {
      headerHtml = wrapEl.append($(headerHtml));
      $('#tyreselector_4 header > .content').html(headerHtml);
    }

    // Show disclaimer if searched by license
    if(window.cookieObj?.tsViewNavItem === '#filterLicense' && window.cookieObj?.license?.data?.id) {
      this.showDisclaimer(true);
    }
  }, // updateTsHeader()

  /**
   * Shows/hides the disclaimer
   *
   * @param {boolean} visible - Visibility state
   */
  showDisclaimer(visible) {
    $('.tyreselector__disclaimer-statement__content').toggleClass('hidden', !visible);
  },

  attachEventListeners: function() {
    var self = this;

    // events for size selection elements (radio buttons and mobile <select>)

    // add change event for mobile select
    $(document).on('change', 'select[name="mobileTyreSize"]', function(e) {
      const value = $(this).val();
      const option = $(this).find('option[value="' + value + '"]');

      // store selected size

      let size = option && option.length ? option.attr('data-size') : '';
      if (size && value && window.cookieObj) {
        size = size.split(',');
        delete window.cookieObj.id;
        delete window.cookieObj.productInfo;
        delete window.cookieObj.productName;
        window.cookieObj.width = ~~size[0]; // convert to integer
        window.cookieObj.height = ~~size[1]; // convert to integer
        window.cookieObj.rim = ~~size[2]; // convert to integer
        window.setTyreCookie();
      }

      // move to new size
      if (value) document.location.href = value;
      else console.log('value missing !');
    });

    // add change event for radio buttons
    $(document).on('change', 'input[type="radio"][name="tyreSize"]', function(
      e
    ) {
      var form = $(this).parents('form'),
        value = $(this).val(),
        select = $(form).find('select[name="mobileTyreSize"]'),
        selectValue = select.length ? $(select).val() : null;

      if (selectValue !== value) {
        $(select).val(value);
        // refresh select2 if it's in use;
        $(select).select2();
      }
    });

    // ------------------------------------------
    // FORM SUBMITS
    // ------------------------------------------

    $('#tyreselector_4 form').on('submit', function(e) {

      self.tsEl.toggleClass('loading', true);
      self.formSubmitted = true; // this is detected by redirectToResult function and it only redirects user if this is true.

      // We do not actually submit anything. This function only stores user's choises and
      // then user is either scrolled to results or moved to "tyres" page by JS
      e.preventDefault();

      var formName = $(this).attr('name');

      // check if we stay on current page or not
      var submitBtn = $(this).find('[type="submit"]'),
        //closeSearch           = submitBtn.hasClass('toggle'),
        scrollToProducts =
          submitBtn.hasClass('scrollPage') &&
          self.tsEl.hasClass('by-tyre-size'),
        headerHeight = $('header.header:first').height(),
        resultFilters = $('.resultFilters:first');

      // close ts search forms
      if (!resultFilters.length) {
        window.cookieObj.closeSearchOnLoad = true;
      }

      // scroll to results
      if (scrollToProducts && headerHeight && resultFilters.length) {
        // New feature: close search on next reload
        // Example: user clicks button -> gets scrolled to results (and search remains open) -> goes to tyre-page -> comes back: now search must be closed, since the size is chosen
        // This feature is accomplished by using a new flag "closeSearchOnLoad" in stored data that makes element closed on next reload.
        window.cookieObj.closeSearchOnLoad = true;

        window.setTyreCookie();

        var useEasing =
            $.easing && $.easing.easeInOutQuad ? 'easeInOutQuad' : 'swing',
          // Desktop: scroll to resultFilters. Mobile: leave space for fixed top bar.
          scrollToPos =
            $(window).width() < 992
              ? $('.resultFilters:first').offset().top - headerHeight
              : $('.resultFilters:first').offset().top;

        $('html, body').animate(
          {
            scrollTop: scrollToPos
          },
          500,
          useEasing
        );
      } else {
        if (formName === 'licenseSearchForm') {
          // reset other forms
          if (window.cookieObj) {
            window.cookieObj.width = undefined;
            window.cookieObj.height = undefined;
            window.cookieObj.rim = undefined;
            if (window.cookieObj.manufacturer)
              delete window.cookieObj.manufacturer;
            if (window.cookieObj.year) delete window.cookieObj.year;
            if (window.cookieObj.model) delete window.cookieObj.model;
            if (window.cookieObj.vehicle) delete window.cookieObj.vehicle;
            if (window.cookieObj.id) delete window.cookieObj.id;
            if (window.cookieObj.productInfo)
              delete window.cookieObj.productInfo;
            if (window.cookieObj.productName)
              delete window.cookieObj.productName;
          }

          if (typeof self.resetTyreSelectorForms === 'function') {
            self.resetTyreSelectorForms(['modelSearchForm', 'sizeSearchForm']);
          }

          var licenseText = $(this)
              .find('[name="license"]')
              .val(),
            licenseCountry = $(this)
              .find('[name="country"]')
              .val();

          if (licenseText && typeof window.cookieObj !== 'undefined') {
            var licenseObj = {
              text: licenseText.toUpperCase(),
              country: licenseCountry
            };
            window.cookieObj.license = licenseObj;

            window.setTyreCookie();
          }

          // on Finnish site only: Check that the license has a dash character (-) between letters and numbers. If it's not there, add it.
          if (
            licenseCountry === 'FI' &&
            typeof window.cookieObj !== 'undefined' &&
            window.cookieObj.license &&
            window.cookieObj.license.text &&
            window.cookieObj.license.text.indexOf('-') === -1
          ) {
            // search first instance of number
            var firstNumberIndex = window.cookieObj.license.text.search(/\d/);
            // there must be at least 1 letter before number, so this value must be bigger than zero
            if (firstNumberIndex > 0) {
              var newString =
                window.cookieObj.license.text.slice(0, firstNumberIndex) +
                '-' +
                window.cookieObj.license.text.slice(firstNumberIndex);
              window.cookieObj.license.text = newString;
              const licenseInput = $('input[name=license]:first');
              if (licenseInput.length) licenseInput.val(newString);

              window.setTyreCookie();
            }
          }

          if (licenseText && licenseCountry) {
            self.licenseForm.getLicenseResults(
              window.cookieObj.license.text,
              window.cookieObj.license.country
            );
          }
        } // licenseSearchForm

        if (formName === 'modelSearchForm') {
          // reset other forms
          if (window.cookieObj) {
            window.cookieObj.width = undefined;
            window.cookieObj.height = undefined;
            window.cookieObj.rim = undefined;
            if (window.cookieObj.license) delete window.cookieObj.license;
            if (window.cookieObj.id) delete window.cookieObj.id;
            if (window.cookieObj.productInfo)
              delete window.cookieObj.productInfo;
            if (window.cookieObj.productName)
              delete window.cookieObj.productName;
          }

          if (typeof self.resetTyreSelectorForms === 'function') {
            self.resetTyreSelectorForms([
              'licenseSearchForm',
              'sizeSearchForm'
            ]);
          }

          self.modelForm.populateForm();
        } // modelSearchForm

        if (formName === 'sizeSearchForm') {
          // reset other forms
          if (window.cookieObj) {
            if (window.cookieObj.license) delete window.cookieObj.license;
            if (window.cookieObj.manufacturer)
              delete window.cookieObj.manufacturer;
            if (window.cookieObj.year) delete window.cookieObj.year;
            if (window.cookieObj.model) delete window.cookieObj.model;
            if (window.cookieObj.vehicle) delete window.cookieObj.vehicle;
            if (window.cookieObj.id) delete window.cookieObj.id;
            if (window.cookieObj.productInfo)
              delete window.cookieObj.productInfo;
            if (window.cookieObj.productName)
              delete window.cookieObj.productName;
          }

          if (typeof self.resetTyreSelectorForms === 'function') {
            self.resetTyreSelectorForms([
              'licenseSearchForm',
              'modelSearchForm'
            ]);
          }
        } // sizeSearchForm
      } // else
    });

    $(document)
      .on('click', '#tyreselector_4 .select2-container--disabled', function(
        e
      ) {
        e.stopPropagation();
        // add a nice fadeout/fadein click effect for disabled select2 elements.
        $(this)
          .fadeOut(200)
          .fadeIn(200);
        return false;
      })
      .on('click', '.tyres-nav a', function(e) {
        // campaign-hero on tyres-page has anchor links. scroll nicely.
        e.preventDefault();
        var that = $(this),
          href = that.attr('href');

        if (href && href.indexOf('#') === 0 && $(href).length) {
          $('html, body').animate(
            {
              scrollTop:
                $(href).offset().top + ($(window).width() < 960 ? -48 : 0) // leave room for floating top bar when it's visible
            },
            500,
            'swing',
            function() {
              document.location.hash = href;
            }
          );
        }
      });
  }, // attachEventListeners()

  tsResultsError: function(errorHtml) {
    // this function hides/shows error message on top of result list, if chosen size is not available in current group
    var parentEl = $('.product-list-background:first'),
      productList = parentEl.find('main.product-list:first'),
      el = parentEl.find('.error');

    if (!parentEl.length) {
      console.warn('tsResultsError(): no parentEl found, exiting...');
      return false;
    }

    if (!el.length && errorHtml) {
      productList.before($(errorHtml));
    } else if (el.length && errorHtml) {
      el.remove();
      productList.before($(errorHtml));
    } else if (el.length) {
      el.remove();
    }
  }, // tsResultsError()

  // v3.1 this function changes ts-header
  parseResults: function(updateTsHeader) {
    var self = this;
    updateTsHeader = updateTsHeader === true ? true : false;

    // check what we know.
    var licenseKnown =
        window.cookieObj &&
        window.cookieObj.license &&
        window.cookieObj.license.data &&
        window.cookieObj.license.data.id
          ? true
          : false,
      vehicleKnown =
        window.cookieObj &&
        window.cookieObj.vehicle &&
        window.cookieObj.vehicle.value
          ? true
          : false,
      modelKnown =
        window.cookieObj &&
        window.cookieObj.model &&
        window.cookieObj.model.value
          ? true
          : false,
      sizeKnown =
        window.cookieObj &&
        window.cookieObj.width &&
        window.cookieObj.height &&
        window.cookieObj.rim
          ? true
          : false,
      licenseSearchAvailable =
        typeof window.licenseSearchInUse !== 'undefined'
          ? window.licenseSearchInUse
          : false,
      defaultTsView = licenseSearchAvailable
        ? '#filterLicense'
        : '#filterSizes',
      currentTsView =
        window.cookieObj && window.cookieObj.tsViewNavItem
          ? window.cookieObj.tsViewNavItem
          : defaultTsView;
    // loadingClassTimer;

    if (
      window.cookieObj.tsViewNavItem === 'undefined' ||
      (!licenseSearchAvailable && currentTsView === '#filterLicense')
    ) {
      window.cookieObj.tsViewNavItem = defaultTsView;
      window.setTyreCookie();
    }

    // if user has searched, user is on top of page, and tsviews are visible, then user should be scrolled to tyreselector.
    if (
      window.cookieObj.tsViews &&
      window.cookieObj.tsViews !== 'hidden' &&
      (licenseKnown || vehicleKnown || modelKnown || sizeKnown)
    ) {
      $('#tyreselector_4').toggleClass('scrollToThis', true);
    }

    // if we've detected that user should be scrolled to tyreselector to view results. then do the scroll. Note that this should only be done in 'tyres' page where results are shown.
    if ($('#tyreselector_4').hasClass('scrollToThis')) {
      $('#tyreselector_4').toggleClass('scrollToThis', false);
      var st = $(document).scrollTop(),
        tsPos = $('#tyreselector_4').length
          ? $('#tyreselector_4').offset().top
          : 0;
      if (st === 0 && tsPos > 0)
        $('html, body').animate(
          { scrollTop: $('#tyreselector_4').offset().top - 48 },
          500
        );
    }

    // choose which user data should be used
    if (licenseKnown && sizeKnown) {
      if (updateTsHeader) {
        self.updateTsHeader('vehicle');
      }
      self.redirectToResult(
        window.cookieObj.width,
        window.cookieObj.height,
        window.cookieObj.rim,
        null,
        null
      );
    }
    // vehicle known
    else if ((vehicleKnown || modelKnown) && sizeKnown) {
      if (updateTsHeader) {
        self.updateTsHeader('model');
      }
      self.redirectToResult(
        window.cookieObj.width,
        window.cookieObj.height,
        window.cookieObj.rim,
        null,
        null
      );
    }
    // Size known
    else if (sizeKnown) {
      self.filterBarUpdatedFor = 'size';
      if (updateTsHeader) {
        self.updateTsHeader('size');
      }
      self.redirectToResult(
        window.cookieObj.width,
        window.cookieObj.height,
        window.cookieObj.rim,
        null,
        null
      );
    }
    // fallback
    else {
      if (updateTsHeader) {
        self.updateTsHeader(); // without viewKey this changes view to default
      }
      // redirectToResult();
    }

  }, // parseResults()

  /**
   * redirectToResult
   * @description
   * This function needs to determine where to redirect the user:
   *     1) choose the correct filterGroup by season (geoIP season or site's active season)
   *     2) add the chosen tyresize to the query parameter "s".
   *     end result should be something like this: /tyres/by-tyre-size/summer-tyres/205-55-16
   *     finally, redirect user to that address.
   * @param {Number} width - tyre width in millimeters
   * @param {Number} height - tyre height (aspect ratio) in millimeters
   * @param {Number} rim - rim size in inches
   * @param {Number} load_index - load index value
   * @param {String} speed_rating - speed rating class
   * @returns {Boolean}
   */
  redirectToResult: function(width, height, rim, load_index, speed_rating) {
    const self = this;
    if (
      typeof width === 'undefined' ||
      !width ||
      typeof height === 'undefined' ||
      !height ||
      typeof rim === 'undefined' ||
      !rim
    ) {
      return false;
    }

    // if
    // 1) we are at the 'by-tyre-size' view and
    // 2) form was submitted
    // 3) submitted size matches with size in page's querystring
    // then just scroll to results
    const scrollToResults =
      self.formSubmitted &&
      self.tsEl.hasClass('by-tyre-size') &&
      self.sizeParameterMatch(~~width, ~~height, ~~rim);

    if (scrollToResults) {
      self.formSubmitted = false;
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $('main.product-list').offset().top
        },
        500
      );
    }

    // this function gets triggered a lot. this seemed the quickest way to filter out all but the form submits.
    if (!self.formSubmitted) {
      return false;
    }
    self.formSubmitted = false;

    // set throbber on since we are redirecting!
    self.tsEl.toggleClass('loading', true);
    // set loading status also for filter-bar, if it's there
    $('.product-list-background .filter-bar').toggleClass('loading', true);

    const season = self.getSeason();
    const filterGroups = window.filterGroups;
    const productGroupFilters = window.productGroupFilters;
    const byTyreSizeCategorySlug = window.tsSettings
      ? window.tsSettings.byTyreSizeCategorySlug
      : false;
    const tyresPage = window.tsSettings ? window.tsSettings.tyresPage : false;

    let filterGroup,
      filterGroupSlug,
      sizeParameter = [width, height, rim].join('-');

    // choose what filtergroup to use in redirection
    // 1) if there's a filterGroup object in window, use it. user may have changed filterGroup.
    // 2) choose by current filtergroup.
    // 3) fallback to current season.
    if (window.filterGroup && window.filterGroup.slug) {
      // 1)
      filterGroup = window.filterGroup;
      filterGroupSlug = window.filterGroup.slug;
    } else {
      if (
        productGroupFilters &&
        window.tsSettings &&
        window.tsSettings.currentFilterSlug
      ) {
        let pgf = productGroupFilters.find(
          p => p.slug === window.tsSettings.currentFilterSlug
        );
        // 2) choose by current filtergroup.
        if (pgf && pgf.productPage && pgf.productPage.ref) {
          // pgf.productPage.ref = product page
          for (let fg of filterGroups) {
            if (fg.product_page === pgf.productPage.ref) {
              filterGroup = fg;
              filterGroupSlug = filterGroup.slug;
              break;
            }
          }
        }
      }
      if (!filterGroupSlug) {
        // 3) fallback to current season.
        for (let fg of filterGroups) {
          if (fg.id === season) {
            filterGroup = fg;
            filterGroupSlug = filterGroup.slug;
            break;
          }
        }
      }
    }

    if (!season || !filterGroup || !byTyreSizeCategorySlug /* !tyreSizes */) {
      console.error('Season or filterGroup or categorySlug missing. Exiting.');
      self.tsEl.toggleClass('loading', false);

      return false;
    }

    const redirectionTarget =
      tyresPage +
      byTyreSizeCategorySlug /* tyreSizes.productGroupSlug */ +
      '/' +
      filterGroupSlug +
      '/' +
      sizeParameter +
      '/';

    window.location.href = redirectionTarget;

    return true;
  }, // redirectToResult()

  /**
   * sizeParameterMatch
   * @description compares "s" query parameter's value with width, height and rim. deconstructs "s" parameter value to w, h and r values by splitting value by any of the found separators: '-','+','%20',' '
   * @param {Number} width Must be integer
   * @param {Number} height Must be integer
   * @param {Number} rim Must be integer
   * @returns {boolean} true if sizes matched
   */
  sizeParameterMatch: function(width, height, rim) {
    const self = this;

    // check if form submit must be changed to scoll to results
    const requestSizeParameter = self.getUrlParameter('s');

    // check if this page was requested with the same size as this function was called.
    // if so, then there's no need to redirect, only scroll to results.
    if (requestSizeParameter) {
      // parameter may contain multiple separators. Check'em all
      const separators = ['-', '+', '%20', ' '];
      let separator;

      // choose first found separator
      for (let i = 0; i < separators.length; i++) {
        if (requestSizeParameter.indexOf(separators[i]) > -1) {
          separator = separators[i];
          break;
        }
      }

      if (!separator) return false;

      const values = requestSizeParameter.split(separator),
        w = ~~values[0], // convert to integer with ~~
        h = ~~values[1], // convert to integer with ~~
        r = ~~values[2]; // convert to integer with ~~

      if (w === width && h === height && r === rim) {
        return true;
      }
    }
    return false;
  },

  /**
   * getUrlParameter
   * @param {sting} name - parameter to fetch
   * @returns {string} parameter value if found, otherwise an empty string.
   */
  getUrlParameter: function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"); // eslint-disable-line
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  /**
   * Get current season
   * @description This method determines what season should be used with current user.
   * 1) Check if GeoIP rules have chosen the season, use it if available
   * 2) Use site's active season
   * @return {(string|boolean)} season - false if could not choose season, otherwise any of the filter group id's summer/winter/studded/non-studded...
   */
  getSeason: function() {
    let season = false;
    // first check if geo_season has selected a season for current user. This feature is in use @ US/CA sites.
    if (storage.session) {
      const geoSeason = sessionStorage.getItem('geo_season');
      if (geoSeason) season = geoSeason.split('_').join('-');
    }
    // if no geoSeason, then use site's active season. Tyreselector adds it to window.
    if (!season && window.season) season = window.season;

    if (!season) {
      // we should never end up here
      console.warn('Tyreselector could not choose season!');
    }

    return season;
  },

  /* =============================
   TYRE PAGE (product page)
   ============================= */

  tyrePage: function() {
    var self = this;

    if (!window.cookieObj) {
      self.tsEl.hide();
      return false;
    }

    // check what we know.
    var licenseKnown =
        window.cookieObj &&
        window.cookieObj.license &&
        window.cookieObj.license.data &&
        window.cookieObj.license.data.id
          ? true
          : false,
      vehicleKnown =
        window.cookieObj &&
        window.cookieObj.vehicle &&
        window.cookieObj.vehicle.value
          ? true
          : false,
      modelKnown =
        window.cookieObj &&
        window.cookieObj.model &&
        window.cookieObj.model.value
          ? true
          : false,
      sizeKnown =
        window.cookieObj &&
        window.cookieObj.width &&
        window.cookieObj.height &&
        window.cookieObj.rim
          ? true
          : false,
      licenseSearchAvailable =
        typeof window.licenseSearchInUse !== 'undefined'
          ? window.licenseSearchInUse
          : false,
      defaultTsView = licenseSearchAvailable
        ? '#filterLicense'
        : '#filterModels',
      currentTsView =
        window.cookieObj && window.cookieObj.tsViewNavItem
          ? window.cookieObj.tsViewNavItem
          : defaultTsView;

    if (
      window.cookieObj.tsViewNavItem === 'undefined' ||
      (!licenseSearchAvailable && currentTsView === '#filterLicense')
    ) {
      window.cookieObj.tsViewNavItem = defaultTsView;

      window.setTyreCookie();
    }

    // update header
    if (licenseKnown && sizeKnown) {
      self.updateTsHeader('vehicle');
    }

    // vehicle known
    else if ((vehicleKnown || modelKnown) && sizeKnown) {
      self.updateTsHeader('model');
    }

    // Size known
    else if (sizeKnown) {
      self.updateTsHeader('size');
    }

    // fallback
    else {
      self.updateTsHeader(); // without viewKey this changes view to default
    }

    self.tsEl.find('form').on('reset', function(e) {
      //updateSizeList(); // without params this just resets size-view
    });

    var sizeLinks = $('ul.wsts-size-links:first').find('a');

    $(document).on('click', '.wsts-size-links a', function() {
      $('ul.wsts-size-links [data-rimfilter]').removeClass('ts-active');
    });

    function updateSizeList(width, height, rim, loadIndex, speedRating) {
      var sizesEl = $('.tyre-size-data:first'),
        trs = sizesEl.length ? $(sizesEl).find('tr.rim-row-item') : [];

      if (!width || !height || !rim) {
        $(sizeLinks).toggleClass('active', false);
        $(trs).hide();
      } else if (sizeKnown) {
        sizesEl.show();
        var sizeStr = width + ',' + height + ',' + rim;
        // open only matching sizes from table
        $(trs).each(function() {
          if ($(this).attr('data-size-values') === sizeStr)
            $(this).css('display', '');
          else $(this).hide();
        });
        // set link to active state
        $(sizeLinks).each(function() {
          if (Number($(this).attr('data-rimfilter')) === window.cookieObj.rim)
            $(this).toggleClass('ts-active', true);
          else $(this).toggleClass('ts-active', false);
        });
      }
    } // updateSizeList()

    if (sizeKnown) {
      updateSizeList(
        window.cookieObj.width,
        window.cookieObj.height,
        window.cookieObj.rim,
        window.cookieObj.load_index,
        window.cookieObj.speed_rating
      );
    }
  }, // tyrePage()

  /* =============================
   Get query string parameter
   ============================= */

  getQueryStringParam: function(param) {
    // this function returns requested query string parameter or an empty string

    if (typeof param === 'undefined' || !param || !window.location.search)
      return '';

    const qs = window.location.search.substring(1);
    const params = qs.split('&');
    let i = 0,
      pair;

    for (i = 0; i < params.length; i++) {
      pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) === param) {
        return decodeURIComponent(pair[1]);
      }
    }

    return '';
  }, // getQueryStringParam()

  // =========================================
  // INIT FUNCTION
  // =========================================

  init: function() {
    console.log('TS4: tyreselector.init()');

    var self = this;

    // push tyreSearch event to dataLayer (GTM) IF we know user's tyre size. (onload)
    if (self.tsEl.length) {
      $(window).on('load', function() {
        let tyreData, sizeKnown;

        // do we have HTML5 storage support?
        if (storage.session) {
          tyreData =
            sessionStorage.getItem('tyreData') ||
            localStorage.getItem('tyreData');
          try {
            tyreData = JSON.parse(tyreData);
            sizeKnown =
              tyreData.width && tyreData.height && tyreData.rim ? true : false;
          } catch (e) {
            tyreData = null;
          }
        }

        if (tyreData && sizeKnown) {
          const eventActions = {
              '#filterLicense': 'License Search',
              '#filterModels': 'Model search',
              '#filterSizes': 'Size Search'
            },
            eventAction = tyreData.tsViewNavItem
              ? eventActions[tyreData.tsViewNavItem]
              : '';

          if (eventAction) {
            if (window.dataLayer) {
              const dlObject = {
                event: 'tyreSearch',
                eventCategory: 'Tyre Selector',
                eventAction: eventAction,
                eventLabel:
                  tyreData.width + '/' + tyreData.height + 'R' + tyreData.rim
              };
              window.dataLayer.push(dlObject);
            } // window.dataLayer
            else console.warn('Tyreselector init: window.dataLayer missing');
          } else console.warn('Tyreselector init: eventAction missing');
        }
      }); // window.load
    } // add window.load

    // Enable submits. They will be disabled later if needed.
    if (self.tsEl.length) self.tsEl.find(':submit').removeAttr('disabled');

    // setup views
    self.toggleTsViews();

    // do extra if we're not @ editor mode
    if (self.tsEl.length && !self.tsEl.hasClass('editor')) self.notEditorInit();

    // attach event listeners
    self.attachEventListeners();

    filterBar.init();

    self.tsEl.show();

    // -----------------------------------------------------------------------
    // results | Tyres page
    // -----------------------------------------------------------------------

    if (self.tsEl.hasClass('tyres')) {
      self.parseResults(true);
    }

    /*
      ------------------------------------------
        TYRE page
      ------------------------------------------
    */

    if (self.tsEl.hasClass('tyre')) self.tyrePage();
  } // init()
};

export default tyreselector;
